(function (angular) {
    angular.module('bizPartEngage').controller('core.register', registerController);

    registerController.$inject = ["$rootScope", "core.registerService", "$translate", "core.users.service", "$window", "bizUser", "$scope"];

    function registerController($rootScope, registerService, $translate, userService, $window, bizUser, $scope) {
        var vm = this;
        vm.Register = Register;
        vm.AcceptedConditions = false;
        vm.Roles = [];
        vm.User = {};
        vm.ReferralSourceSelections = {};
        vm.Message = '';
        vm.IsEmailValid = IsEmailValid;
        vm.IsMobileValid = IsMobileValid;
        vm.GenderClick = GenderClick;
        vm.GetGender = GetGender;
        vm.GetUnits = GetUnits;
        vm.GetParentUnitNoSelectTextFunction = GetParentUnitNoSelectTextFunction;
        vm.IsLeafUnit = IsLeafUnit;
               
        vm.MobilePattern = /^\+[0-9]{10,}$/;
        vm.EmailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        //much of the code here is for the possibility of use in custom views, that might not be used in the default view (yet)       
        
        function BuildUserSettings() {
            //console.log("BuildUserSettings", vm.UserSettings); 
            if (!vm.UserSettings) return;

            var userSettingsByKey = {};
            var userSettingsList = [];
            (vm.UserSettings || []).forEach(function (x) {
                //console.log("existing user setting", x); 
                if (!$rootScope.MiniSettings.Register.UserSettingsFilterFn || $rootScope.MiniSettings.Register.UserSettingsFilterFn(x, { unit: vm.SelectedUnit })) {                    
                    //console.log("including existing user setting", x); 
                    userSettingsByKey[x.Key] = x;
                    userSettingsList.push(x);
                }
            });            

            vm.UserSettingsByKey = userSettingsByKey;
            vm.UserSettingsList = userSettingsList;
        }        

        function GetUserSettingsForSubmit() {
            var userSettings = [];
            var configuredUserSettings = vm.UserSettingsList || [];
            for (var i = 0; i < configuredUserSettings.length; i++) {
                var us = configuredUserSettings[i];
                if (vm.UserSettingsByKey[us.Key].Value) {
                    userSettings.push(vm.UserSettingsByKey[us.Key]);
                }
            }

            var referralSourceOptions = vm.Config?.ReferralSourceOptions || [];
            for (var referralIndex = 0; referralIndex < referralSourceOptions.length; referralIndex++) {
                var referralSource = referralSourceOptions[referralIndex];
                if (vm.ReferralSourceSelections[referralSource]) {
                    userSettings.push({
                        Key: 'Register_ReferralSource',
                        Value: referralSource
                    });
                }
            }

            return userSettings;
        }
        
        function GetParentUnitNoSelectTextFunction() {
            return function (parent) {
                var nextUnitLevelList = GetUnitsByParent(parent ? parent.Id : -1);

                //assume all units on same level have same UnitTypeName
                var nextUnitTypeName = nextUnitLevelList.length > 0 ? nextUnitLevelList[0].UnitTypeName : 'N/A';           

                return vm.UnitParentSelectNoSelectText.replace('##UNITTYPE##', nextUnitTypeName);                
            }
        }        

        function GetUnitsByParent(parentId) {                            
            if (!vm.Config?.AllowedUnits) {
                return [];
            }

            if (!parentId || parentId <= 0) {
                parentId = -1;
            }

            return vm.Config.AllowedUnits.filter(u => u.ParentId === parentId);            
        }

        function IsLeafUnit(unit) {
            if (!unit) return false;
            return GetUnitsByParent(unit.Id).length === 0;
        }

        function GetUnits() {
            return GetUnitsByParentPromise;
        }

        function GetUnitsByParentPromise(parentId) {            
            //console.log("GetUnits", parentId);
            return new Promise(function (resolve, reject) {
                //simulate async backend call
                resolve({ data: GetUnitsByParent(parentId) });
            });            
        }
        
        function Init() {
            if ($rootScope.MiniSettings.Register.OverrideMobilePattern) {
                vm.MobilePattern = $rootScope.MiniSettings.Register.OverrideMobilePattern;
            }            

            if ($rootScope.MiniSettings.Register.UserSettingsGetFn) {
                $rootScope.MiniSettings.Register.UserSettingsGetFn().then(function (userSettings) {
                    if ($rootScope.MiniSettings.Register.UserSettings) {
                        userSettings = $rootScope.MiniSettings.Register.UserSettings.concat(userSettings);
                    }
                    vm.UserSettings = userSettings;
                    BuildUserSettings();
                })
            } else {
                vm.UserSettings = $rootScope.MiniSettings.Register.UserSettings;
                BuildUserSettings();
            }
                        
            userService.GetGenders().then(GetGendersCallback);
            registerService.GetConfiguration().then(GetConfigurationCallback);

            $translate('CORE.REGISTER.UNIT_PARENT_SELECT_NO_SELECT_TEXT').then(function (translation) {
                vm.UnitParentSelectNoSelectText = translation?.toString() || '-- Välj ##UNITTYPE## --';
            });

            function GetGendersCallback(response) {
                vm.Genders = BizPartCoreHelpers.getResponseValue(response);
            }

            function GetConfigurationCallback(response) {
                vm.Config = BizPartCoreHelpers.getResponseValue(response);
                //console.log("register config", vm.Config);
            }            

            vm.IsLoggedIn = bizUser.IsLoggedIn();     

            $scope.$watch('vm.SelectedUnit', function (newVal, oldVal) {
                BuildUserSettings();
            });
        }

        function GenderClick(gender) {
            for (var i = 0; i < vm.Genders.length; i++) {
                vm.Genders[i].checked = vm.Genders[i] === gender;
            }
        }

        function IsMobileValid() {
            if (!$rootScope.MiniSettings.Register.MobileIsMandatory && !vm.User.Mobile) return true;

            if (!vm.User.Mobile) return false;

            return vm.MobilePattern.test(vm.User.Mobile)
        }

        function IsEmailValid() {
            if (!vm.User || !vm.User.Email) return false;
            if (!vm.EmailPattern) return true;

            return vm.EmailPattern.test(vm.User.Email);
        }

        function GetGender() {
            for (var i = 0; i < vm.Genders.length; i++) {
                if (vm.Genders[i].checked) {
                    return vm.Genders[i].SystemName;
                }
            }
            return null;
        }

        function Register()
        {
            var gender = vm.GetGender();

            var isGenderValid = !$rootScope.MiniSettings.Register.GenderIsMandatory || gender;
            var isUnitValid = !$rootScope.MiniSettings.Register.UnitIsMandatory || vm.SelectedUnit;
            var isLeafUnitValid = !$rootScope.MiniSettings.Register.RequireLeafUnit || IsLeafUnit(vm.SelectedUnit);            
            
            vm.ShowValidation = true;            

            if (vm.MyForm.$valid && isGenderValid && isUnitValid && isLeafUnitValid && vm.AcceptedConditions == true && !vm.Submitting && !vm.Submitted && !vm.IsLoggedIn) {
                console.log("submitted");

                vm.ShowValidation = false;
                vm.Submitting = true;
                vm.Message = '';

                vm.User.Gender = gender;
                vm.User.IsActive = true;
                vm.User.CultureId = $rootScope.LoggedInUser.CurrentCultureId;
                vm.User.strCulture = $rootScope.Cultures.GetItemByValue('Id', $rootScope.LoggedInUser.CurrentCultureId).CultureCode;

                if (vm.SelectedUnit) {
                    vm.User.Units = [vm.SelectedUnit];
                }

                vm.User.UserSettings = GetUserSettingsForSubmit();
                
                registerService.CreateUser(vm.User).then(registerSuccess);

                function registerSuccess(response) {
                    vm.Submitted = true;
                    vm.Submitting = false;
                    vm.Success = response.data.Success;

                    if (response.data.Success == true) {
                        $translate('CORE.REGISTER.USERCREATED').then(function (translation) {
                            vm.SuccessMessage = translation || 'Follow the instructions mailed to you in order to verify your email address and select a password.';
                        });
                    }
                    else {
                        vm.Message = response.data.Message;
                    }

                    if ($window.dataLayer) {
                        $window.dataLayer.push({
                            event: 'form.Submit',
                            attributes: {
                                key: 'register-user-form',
                                success: vm.Success
                            },
                        });
                    }
                }
            } else if (vm.IsLoggedIn) {
                vm.Submitted = true;
                vm.Submitting = false;
                vm.Success = false;
                vm.Message = 'You are logged in. Logout and try again.';
            }
        }

        vm.$onInit = Init;
    }
})(window.angular);
